import React from 'react';
import LegalPage from './LegalPage';

const TermsPage: React.FC = () => <LegalPage file="TERMS_OF_SERVICE.md" />;

export default TermsPage;
